const DEFAULT_TIMESTAMP_EMPTY_LABEL = '—';
const DEFAULT_TIMESTAMP_FORMAT_OPTIONS = Object.freeze({
  dateStyle: 'medium',
  timeStyle: 'short'
});

const normalizeTimestampValue = (value) => {
  if (value === null || value === undefined) {
    return '';
  }

  return String(value).trim();
};

export const formatTimestamp = (value) => {
  const normalized = normalizeTimestampValue(value);

  if (!normalized) {
    return DEFAULT_TIMESTAMP_EMPTY_LABEL;
  }

  const timestamp = Date.parse(normalized);

  if (!Number.isFinite(timestamp)) {
    return normalized;
  }

  try {
    return new Intl.DateTimeFormat(undefined, DEFAULT_TIMESTAMP_FORMAT_OPTIONS).format(new Date(timestamp));
  } catch {
    return normalized;
  }
};
